import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/lifetimeValueByMembershipsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const CustomDateRanges = () => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state.lifetimeValueByMembership.rangeOptions);
  const selectedFilters = useSelector(
    (state) => state.lifetimeValueByMembership.selectedRangeOption
  );

  const handleUpdateOptions = (data) => {
    dispatch(actionCreators.updateCustomRange(data));
  };

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilters}
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={handleUpdateOptions}
    />
  );
};

export default CustomDateRanges;
